/* src/app/self-enrollment/Privacy/privacy.component.css */
.enroll {
  padding-bottom: 40px;
  background-image:
    linear-gradient(
      to bottom right,
      #dae5f0,
      white);
}
a {
  text-decoration: underline;
  color: inherit;
}
.form-control.input-sm {
  font-size: 13px;
}
/*# sourceMappingURL=privacy.component.css.map */
